import React from "react";
import HomeMiddleBanners from "../components/HomeMiddleBanners";
import { t } from "../../../helpers";
import { PHOTOS_URL } from "../../../constants";
import { Link } from "react-router-dom";
import { Button } from "@cocunat/ui-components";

type ImStatelessProps = {
  lang: string;
  country: string;
  region: any;
};

const HeroDesktop = React.memo<ImStatelessProps>((props) => {
  const QUIZ_URL = `/${props.lang}-${props.country}/quizz/1/`;
  return (
    <section className="hero">
      <div className="hero-top">
        <div className="innerText">
          <p
            style={{ margin: 0, marginRight: 10 }}
            dangerouslySetInnerHTML={{
              __html: t("home.heroTop", {
                price: props.region.extra.club_price,
              }),
            }}
          />
        </div>
        <div className="innerPhoto">
          <img src={`${PHOTOS_URL}discount-white-icon.png`} alt="" />
        </div>
      </div>
      <div
        className="hero-main hero-main-mobile"
        style={{
          backgroundImage: `url(https://resizing.cocunat.com/r/?fit=contain&image=${t(
            "home.heroImgMobile"
          )})`,
          backgroundColor: "#a1bcc7",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="heroBtn">
          <Link to={`${QUIZ_URL}`}>
            <Button>{t("home.heroBtn")}</Button>
          </Link>
        </div>
      </div>
      <div
        className="hero-main hero-main-desktop"
        style={{
          backgroundImage: `url(https://resizing.cocunat.com/r/?fit=contain&image=${t(
            "home.heroImgDesktop"
          )})`,
          backgroundColor: "#a1bcc7",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="heroBtn">
          <Link to={`${QUIZ_URL}`}>
            <Button>{t("home.heroBtn")}</Button>
          </Link>
        </div>
      </div>
      <div
        className="hero-bottom mobile"
        style={{
          backgroundImage: `url(${t("home.heroClaimMobile")})`,
          backgroundColor: "rgb(249 208 204)",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      ></div>
      <div
        className="hero-bottom desktop"
        style={{
          backgroundImage: `url(${t("home.heroClaimDesktop")})`,
          backgroundColor: "rgb(249 208 204)",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      ></div>
    </section>
  );
});
export default HeroDesktop;
